import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import useManagement from 'client/hooks/useManagement'
import { getShownSearchResults } from 'client/reducers/managementReducer'
import { EntityProps } from 'client/types'
import React from 'react'
import { CommonSearch } from 'src/shared/entities/search'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import { SearchMockConnector } from './utils/search-mock-connector'

export const Search = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<SearchInterface>) => {
  const connector = new SearchMockConnector()
  const config = {
    apiConnector: connector,
    trackUrlState: false,
    searchQuery: {},
    autocompleteQuery: {},
  }
  const { list: shownSearchResults } = useManagement(getShownSearchResults)
  const isShowSearchResult = shownSearchResults.includes(entity.htmlAttrId)
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonSearch
        isPreviewMode
        showDropdown={isShowSearchResult}
        config={config}
        item={entity.item}
        itemTitle={entity.itemTitle}
        itemText={entity.itemText}
        seeMore={entity.seeMore}
        dropdown={entity.dropdown}
        input={entity.input}
      />
    </BaseEntityNew>
  )
}
